import { format, parse } from 'date-fns';
import { IPeriod, IPeriodStr } from '.';

export enum ChartGroupBy {
    day = 'day',
    month = 'month'
}

export interface IChartPeriod {
    start: Date;
    end: Date;
    groupBy: ChartGroupBy;
}

export interface IChartPeriodStr extends IPeriodStr {
    groupBy: ChartGroupBy;
}
